module.exports = function() {
  return new Worker(__webpack_public_path__ + "01482bebf609fffebf6f.worker.js");
};